import axios from 'axios';
import { DATA_API_URL } from '../config';

interface Config {
  lightConditions: string[];
  climateConditions: string[];
  truckTypes: string[];
  entryTypes: string[];
  bedColors: string[];
}

let cachedConfig: Config | null = null;

export const getConfig = async (): Promise<Config> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    const response = await axios.get(`${DATA_API_URL}/data-server/v1/config`);
    cachedConfig = response.data as Config;
    return cachedConfig;
  } catch (error) {
    console.error('Error fetching configuration:', error);
    // Return default values if API fails
    return {
      lightConditions: ['clear', 'cloudy', 'night'],
      climateConditions: ['sunny', 'rainy', 'cloudin', 'night'],
      truckTypes: ['truck', 'ace', 'riksha', '4x4'],
      entryTypes: ['in', 'out'],
      bedColors: ['white', 'black', 'blue', 'red', 'green', 'yellow', 'gray', 'other']
    };
  }
}; 